import React, { ReactNode } from "react";
import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";

import { colors } from "../../../styles/variables";
import { useTopInsetBg } from "../../organisms/Layout/context";

const Section = styled.section<{ xs?: boolean; xl?: boolean; xxs?: boolean; bgColor?: string }>`
  position: relative;
  padding: ${(props) => (props.xs && "40px 0") || (props.xl && "160px 0") || (props.xxs && "0") || "80px 0"};
  background-color: ${(props) => props.bgColor && props.bgColor};
  ${breakpoints.smDown} {
    padding: ${(props) => (props.xxs && "0") || "50px 0"};
  }
`;

const SectionPeach = styled(Section)`
  background-color: ${colors.peach};
`;

/* Page-leading SectionPeach for in-flow pages where the peach band
 * is the very first element in <main>. Registers peach with the
 * top-inset stack so Layout's TopInsetSpacer paints the notch zone
 * with the same colour — that's how the peach "bleeds up" under the
 * status bar without the band itself needing to extend to viewport
 * y=0 (which it can't, since `.content` pads env(safe-area-inset-
 * top) globally to push flow content below the inset).
 *
 * Use this when the peach band is the page's leading element. Don't
 * use it for a peach band that appears mid-page — there's nothing to
 * bleed into and pushing peach onto the inset stack would mismatch
 * whatever's actually at viewport y=0 there. */
const PageSectionPeach = ({ children, className }: { children?: ReactNode; className?: string }) => {
  useTopInsetBg(colors.peach);
  return <SectionPeach className={className}>{children}</SectionPeach>;
};

const SectionPeachTint = styled(Section)`
  background-color: ${colors.peachTint};
`;

const SectionBlue = styled(Section)`
  background-color: ${colors.blue};
`;

export { Section, SectionPeach, PageSectionPeach, SectionPeachTint, SectionBlue };
